import { Select } from 'twyne-new.ui'

import { decodeMultiValue, encodeMultiValue, getChange, getValue } from './utils'

export default function SelectFilter({ isMulti, options, onChange, name, value, Component = Select, creatable = false }) {
  const isCreatable = typeof creatable === 'boolean' ? creatable : false
  const selectOptions = isMulti ? options.map(option => ({ ...option, value: encodeMultiValue(option.value) })) : options
  const selectValue = isMulti && Array.isArray(value) ? value.map(encodeMultiValue) : value
  const handleChange = isMulti ? values => onChange(values.map(decodeMultiValue)) : onChange

  return <Component
    id={name}
    options={selectOptions}
    value={getValue(selectValue, isMulti)}
    onChange={getChange(handleChange, isMulti)}
    clearable
    creatable={isCreatable}
  />
}
